import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { pillarArticles, type ArticleLanguage } from '@/mocks/articles';

export default function PillarSection() {
  const { t, i18n } = useTranslation();
  const lang = (i18n.language in { en: 1, pl: 1, es: 1, fr: 1 }
    ? i18n.language
    : 'en') as ArticleLanguage;

  return (
    <section className="py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="text-center">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            {t('pillar.title')}
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
            {t('pillar.subtitle')}
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {pillarArticles.map((article) => {
            const content = article[lang] || article.en;
            return (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-white transition-colors hover:border-primary-300"
              >
                <div className="h-40 w-full overflow-hidden">
                  <img
                    src={article.image}
                    alt={content.title}
                    title={`${content.title} — USFans Spreadsheet`}
                    className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-1 flex-col p-4">
                  <h3 className="text-sm font-bold leading-snug text-foreground-950 md:text-base">
                    {content.title}
                  </h3>
                  <p className="mt-2 flex-1 text-xs leading-relaxed text-foreground-600 md:text-sm">
                    {content.description}
                  </p>
                  <span className="mt-3 inline-flex items-center gap-1 text-xs font-bold text-primary-700">
                    {t('category.visit')}
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}